import { SwitchComponent } from '@syncfusion/ej2-react-buttons';
import {
  DropDownListComponent,
  MultiSelectComponent,
} from '@syncfusion/ej2-react-dropdowns';
import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import React, { Component } from 'react';
import { BiX } from 'react-icons/bi';
import { BsCheck2 } from 'react-icons/bs';
import { all_information, loadingShow } from '../../../App';
import Message from '../../../utils/Message/Message';
import './security.css';
import {
  AddCampany,
  DeleteCampany,
  EditCampany,
  getSites,
  getCompany,
} from '../../../services/Company/CompanyServices';
interface IState {
  siteData: any;
  companyData: any;
}
interface IProps {
  GridHeight?: any;
}
export class CompanySites extends Component<IProps, IState> {
  private sitesGrid: GridComponent;
  public validationRule: Object = { required: true };
  private dropDownListObjectOrganizationCode: any;
  private dropDownListObjectSitesStatus: any;
  constructor(props: IProps) {
    super(props);
    this.sitesGrid = new GridComponent(props);
    this.state = {
      siteData: [],
      companyData: [],
    };
  }
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    'ColumnChooser',
    'ExcelExport',
    'Search',
  ];
  public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
    showDeleteConfirmDialog:true
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  SavePointDelete(obje: any) {
    const obj = JSON.stringify({
      organization_id: obje[0].org_id,
    });
    DeleteCampany(obj)
      .then((res) => {
        loadingShow(false);
        Message.success('Successfully');
        this.getSitess();
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  }
  SavePointAdd(data: any) {
    let parentOrgID = this.dropDownListObjectOrganizationCode;
    let status = this.dropDownListObjectSitesStatus.checked;
    if (parentOrgID.text === (undefined || null)) {
      Message.error('Can not be empty organization code');
      this.getSitess();
      return false;
    }
    loadingShow(true, 'Adding');
    const obj = {
      organization_code: data.site_name,
      status: status,
      isParent: false,
      app: 'UWORK',
      description: data.s_description,
      parent_organization_id: parentOrgID.value,
      created_by: all_information.user_id,
      creation_date: new Date(),
    };
    AddCampany(obj)
      .then((res) => {
        loadingShow(false);
        Message.success('Successfully');
        this.getSitess();
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  }
  SavePointEdit(data: any) {
    let parentOrgID = this.dropDownListObjectOrganizationCode;
    let status = this.dropDownListObjectSitesStatus.checked;
    if (parentOrgID.text === (undefined || null)) {
      Message.error('Can not be empty organization code');
      this.sitesGrid.refresh();
      return false;
    }
    loadingShow(true, 'Editing');
    const obj = {
      organization_code: data.site_name,
      app: 'UWORK',
      status: status,
      isParent: false,
      description: data.s_description,
      organization_id: data.org_id,
      parent_organization_id: parentOrgID.value,
      created_by: all_information.user_id,
      creation_date: new Date(),
    };
    EditCampany(obj)
      .then((res) => {
        loadingShow(false);
        Message.success('Successfully');
        this.getSitess();
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  }
  componentDidMount() {
    this.getSitess();
    this.getCompanies();
  }
  getSitess() {
    getSites()
      .then((el) => {
        this.setState({ siteData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  getCompanies() {
    getCompany()
      .then((el) => {
        this.setState({ companyData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  toolbarClick(args: any) {
    if (args.item.id === 'refresh') {
      this.getSitess();
    }
    if (this.sitesGrid && args.item.id === 'gridCompanySites_excelexport') {
      this.sitesGrid.excelExport();
    }
  }
  private isSitesStatustemplate(args: any) {
    let isChecked = args.s_status;
    return (
      <div>
        {isChecked ? (
          <BsCheck2 size={20} color='green' />
        ) : (
          <BiX size={20} color='red' />
        )}
      </div>
    );
  }
  actionBeginSite(args: any) {
    if (args.action === 'add') {
      this.SavePointAdd(args.data);
    } else if (args.action === 'edit') {
      this.SavePointEdit(args.data);
    } else if (args.requestType === 'delete') {
      this.SavePointDelete(args.data);
    }
  }
  private isSitesStatustemplateEditing(args: any) {
    return (
      <SwitchComponent
        checked={args.s_status}
        ref={(scope) => (this.dropDownListObjectSitesStatus = scope)}
      />
    );
  }
  private CompanyTemplateEditing(args: any) {
    return (
      <DropDownListComponent
        placeholder='Company Name'
        text={args.organization_code}
        value={args.organization_id}
        fields={{
          text: 'organization_code',
          value: 'organization_id',
        }}
        dataSource={this.state.companyData}
        ref={(scope) => (this.dropDownListObjectOrganizationCode = scope)}
      />
    );
  }
  render() {
    return (
      <div>
        <GridComponent
          id='gridCompanySites'
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          dataSource={this.state.siteData}
          height='calc(-220px + 100vh)'
          ref={(theGrid: GridComponent) => (this.sitesGrid = theGrid)}
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={this.pageOptions}
          showColumnMenu={true}
          allowResizing={true}
          allowGrouping={true}
          allowExcelExport={true}
          showColumnChooser
          toolbarClick={this.toolbarClick.bind(this)}
          actionBegin={this.actionBeginSite.bind(this)}
          gridLines='Both'
        >
          <ColumnsDirective>
            <ColumnDirective
              field='organization_code'
              headerText='Organization Code'
              textAlign='Left'
              editType='dropdownedit'
              editTemplate={this.CompanyTemplateEditing.bind(this)}
            />
            <ColumnDirective
              field='site_name'
              headerText='Site Name'
              textAlign='Left'
            />
            <ColumnDirective
              field='s_description'
              headerText='Description'
              textAlign='Left'
              validationRules={this.validationRule}
            />

            <ColumnDirective
              field='s_status'
              headerText='Status'
              textAlign='Left'
              template={this.isSitesStatustemplate.bind(this)}
              editTemplate={this.isSitesStatustemplateEditing.bind(this)}
              width={'30px'}
              minWidth={'30px'}
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              Page,
              ColumnChooser,
              ExcelExport,
              ColumnMenu,
              Resize,
              Group
            ]}
          />
        </GridComponent>
      </div>
    );
  }
}

export default CompanySites;
